<template>
  <div class="pc-list" ref="list">
    <BestPracticeSearch @search="search" ref="reSearch"/>

    <div class="pc-list-head">
      <!-- <el-checkbox v-model="isSelectAll" @change="selectAll">全选</el-checkbox> -->
      <!-- <el-checkbox v-model="isSelectAll">全选&nbsp;&nbsp;{{ '(已选' + selectCount + '个)' }}</el-checkbox> -->
      <div class="pc-list-head-handle">
        <div class="pc-list-head-btn">
          <button @click="deleteUser">删除</button>
          <span></span>
          <button @click="addUser">添加</button>
          <span></span>
          <button @click="exportUser">导出数据</button>
        </div>
        <p>{{ "共" + dataArgs.total + "条" }}</p>
      </div>
    </div>

    <el-table class="pc-list-table" :data="dicList" @sort-change="changeSort">
      <el-table-column width="100" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
      fixed="left"
        prop="id"
        label="ID"
        sortable
        width="120"
      ></el-table-column>
      <el-table-column
      fixed="left"
        prop="title"
        label="中文名称"
        width="160"
      ></el-table-column>
      <el-table-column
        prop="englishTitle"
        label="英文名称"
        width="160"
      ></el-table-column>
      <el-table-column label="封面图" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.coverImage" class="eltable-img">
            <img :src="scope.row.coverImage" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="标签" width="230">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.tags" :key="index">
            {{ item.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="awardId"
        label="奖项"
        sortable
        width="150"
      >
      
               <template slot-scope="scope">
           <!-- 1
          {{ scope.row }} -->
          <span v-if="scope.row.award">
          {{ scope.row.award.name == null ? scope.row.award.englishName  :  scope.row.award.name}}
          </span>
      </template> 
      
      </el-table-column>
      <el-table-column
        prop="authorId"
        label="设计师"
        sortable
        width="150"
      >
         <template slot-scope="scope">
           <!-- 1
          {{ scope.row }} -->
          <span v-if="scope.row.author">
          {{ scope.row.author.name == null ? scope.row.author.englishName  :  scope.row.author.name}}
          </span>
      </template> 

      </el-table-column>
      <el-table-column
        prop="company"
        label="事务所"
        width="170"
        sortable
      ></el-table-column>
      <el-table-column label="状态" prop="status" sortable="custom" width="120">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#91CC75"
            @change="changeState(scope.row)"
            inactive-color="#C7C7C7"
            :class="{
              'switch-is-active': scope.row.status,
              'switch-is-not-active': !scope.row.status
            }"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" sortable="custom" width="120">
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.createTime).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column width="120">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>

    <Pagination
      v-if="dicList.length > 0"
      class="pagination"
      :pagination="dataArgs"
      @goPage="goPage"
      @handleCurrentChange="goPage"
      @goLastPage="goPage"
      @goFirstPage="goPage"
    />
    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
    />
    <ExportTable
      :tableData="selectedItems"
      :exportFeild="exportFeild"
      ref="exportTable"
    />
  </div>
</template>



<script>
import Pagination from "../../../template/Pagination";
import BestPracticeSearch from "./BestPracticeSearch";
import DeleteHint from "../../../template/DeleteHint";
import {
  getPractices,
  updatePractice,
  deletePractices
} from "../bestPracticeList.gql";
// 导出数据
import ExportTable from "../../../template/exportTable.vue";
export default {
  components: {
    BestPracticeSearch,
    Pagination,
    ExportTable,
    DeleteHint
  },
  watch: {},
  data() {
    return {
      selectIndex: null,
      isCancelSingle: true,
      isSelectAll: false,
      selectCount: 0,
      userArgs: {
        skip: 0,
        take: 5,
        status: 1,
        order: "+id"
      },
      // 大学的后端接口
      dataArgs: {
        keywords: null,
        take: 10,
        skip: 0,
        order: "-id",
        type: null,
        status: -1
      },
      // 大学数组
      dicList: [],
      // 已选择的下标
      checked: [],
      // 导出数据用的
      selectedItems: [],
      exportFeild: [
        { label: "ID", prop: "id" },
        { label: "中文名称", prop: "title" },
        { label: "英文名称", prop: "englishTitle" },
        { label: "封面图", prop: "coverImage" },
        { label: "内容", prop: "content" },
        { label: "英文内容", prop: "englishContent" },
        { label: "经度", prop: "lng" },
        { label: "纬度", prop: "lat" },
        { label: "位置", prop: "position" },
        { label: "标签", prop: "tags2" },
        { label: "收藏数", prop: "collectNums" },
        { label: "奖项", prop: "award.awardName" },
        { label: "设计师", prop: "author.name" },
        { label: "事务所", prop: "company" },
        { label: "创建时间", prop: "createTime1" },
        { label: "更新时间", prop: "updateTime1" },
        { label: "状态", prop: "status1" },
      
      ],
      //  删除提示框
      deleteDialogVisible: false
    };
  },
  created() {
    // 判断路由查看是否需要根据奖项查询Table
    this.routerAwardsTable();
    // this.getUsers();
  },
  mounted() {
    this.getPractices();
  },
  methods: {
    // 判断路由查看是否需要根据奖项查询Table
    routerAwardsTable() {
      if (this.$route.path == "/admin/awardslist") {
        this.dataArgs.keywords = this.$route.query.name;
      } else {
        console.log("列表页");
      }
    },
    // 大学的后端接口
    getPractices() {
      
      this.$global.GraphqlQuery(this, getPractices, this.dataArgs).then(res => {
        this.checked = [];
        this.dataArgs.total = res.total;
        for (let i = 0; res.data.length > i; i++) {
          res.data[i].isSelect = false;
          if (res.data[i].status == "1") {
            res.data[i].status = true;
          } else {
            res.data[i].status = false;
          }
          if (res.data[i].award != null) {
            if (
              res.data[i].award.name == null &&
              res.data[i].award.id != null
            ) {
              res.data[i].award.awardName = res.data[i].award.englishName;
            } else {
              res.data[i].award.awardName = res.data[i].award.name;
            }
          }
           let tags = "";
            res.data[i].tags.forEach((item, index) => {
              if (index < 3) {
                tags += item.name + ",";
              }
            });
            if(res.data[i].collectNums == null ){
              res.data[i].collectNums = 0
            }
            res.data[i].tags2 = tags.substr(0, tags.length - 2);
          res.data[i].updateTime1 = this.$dtime(res.data[i].updateTime).format("YYYY-MM-DD HH:MM:SS")
          res.data[i].createTime1 = this.$dtime(res.data[i].createTime).format("YYYY-MM-DD HH:MM:SS")
          // res.data[i].status = res.data[i].status == "1" ? true : false;
        }
        this.dicList = res.data;
        // this.tabName = '1'
        this.removeTag();
      });
    },
    // 过滤标签
    removeTag() {
      for (let i = 0; this.dicList.length > i; i++) {
        let a = [];
        a.push(this.dicList[i].name);
        this.dicList[i].city && a.push(this.dicList[i].city.name);
        this.dicList[i].country && a.push(this.dicList[i].country.name);
        this.dicList[i].continent && a.push(this.dicList[i].continent.name);
        this.dicList[i].tags.forEach((tag, index) => {
          a.forEach(item => {
            if (item == tag.name) {
              this.dicList[i].tags.splice(index, 1);
            }
          });
        });
        this.dicList[i].tags = this.dicList[i].tags.slice(0, 3);
      }
    },
    // 修改状态
    changeState(rowScope) {
      rowScope.status = (rowScope.status == false) == true ? 0 : 1;
      let { status, tags } = rowScope;
      const subEntity = {
        status,
        tags
      };

      this.$global
        .GraphqlMutation(this, updatePractice, {
          data: subEntity,
          id: rowScope.id
        })
        .then(res => {
          this.getPractices();
          this.$global.success(this, "操作成功");
        });
    },
    isDelete() {
      let data = { ids: this.checked };
      this.$global
        .GraphqlMutation(this, deletePractices, {
          // Parameters
          data: data
        })
        .then(res => {
          this.getPractices();
          this.deleteDialogVisible = false;
        });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    viewDetail(item) {
     let route = this.$router.resolve({
        path: "/admin/bestpracticedetail",
        query: { id: item.id },
        name: "bestpracticedetail",
        params: item
      });
      window.open(route.href, "_blank");
    },

    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.selectedItems = [];
        this.dicList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
          if (item.status == true) {
            item.status1 = "有效";
          } else {
            item.status1 = "失效";
          }
          this.selectedItems.push(item);
        });
      } else {
        this.dicList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
          this.selectedItems = [];
          if (item.status == true) {
            item.status1 = "有效";
          } else {
            item.status1 = "失效";
          }
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            this.selectedItems.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (row.status == true) {
          row.status1 = "有效";
        } else {
          row.status1 = "失效";
        }
        this.selectedItems.push(row);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },
        // 排序
    changeSort(val){
      if(val.order=='ascending'){
        this.dataArgs.order = "+" + val.prop
      }
      if(val.order=='descending'){
        this.dataArgs.order = "-" + val.prop
      }
      if(val.order==null){
        this.dataArgs.order = '-updateTime'
      }
      this.dataArgs.skip = 0
      this.getPractices()
    },
    search(val) {
      // 计算keyworlds
      // 查看创建时间是否为空
      if(val.createTime==null){
        val.createTime=[]
      }
      this.dataArgs = {
        keywords: val.keywords,
        title: val.title,
        id: val.id,
        fromCreateTime: val.createTime[0],
        toCreateTime: val.createTime[1],
        take: 10,
        skip: 0,
        total: 0,
        order: "-updateTime",
        type: null,
        status: -1
      };
      this.getPractices();
    },
    // 需要回调 
    neeedReSearch(){
      this.$refs.reSearch.getTagTypes()
    },
    // 删除用户
    deleteUser() {
      this.deleteDialogVisible = true;
    },
    // 添加用户
    addUser() {
     let route = this.$router.resolve({
        path: "/admin/bestpracticedetail",
        name: "bestpracticedetail"
      });
      window.open(route.href, "_blank");
    },
    // 到出数据
    exportUser() {
      this.$refs.exportTable.exports();
    },

    goPage(data) {
      this.dataArgs.skip = (data - 1) * 10;
      this.getPractices();
      window.scrollTo(0, this.$refs.list.offsetTop + 210);
    }
  }
};
</script>



<style lang="scss" scoped>
.pc-list {
  margin-top: 45px;
  padding: 55px 30px 55px 40px;
  border-radius: 4px;
  box-shadow: $shadowCard;
  .pc-list-head {
    border-top: 1px solid #c0c0c0;
    padding-top: 30px;
    margin-bottom: 25px;
    letter-spacing: 1px;
    font-family: $chinese;
    font-size: 14px;
    color: $mainTitle;
    .pc-list-head-handle {
      // float: right;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 20px;
      .pc-list-head-btn {
        display: flex;
        border: 1px solid $schoolTagBorder;
        margin-right: 30px;
        border-radius: 4px;
        button,
        p {
          cursor: pointer;
          font-family: $chinese;
          font-size: 14px;
          color: $timeWorld;
          letter-spacing: 1px;
        }

        button {
          width: 100px;
          // height: 30px;
          background: none;
          outline: none;
          padding: 10px 0px;
          box-sizing: content-box;
          border: none;
        }
        span {
          height: 16px;
          border: 1px solid $schoolTagBorder;
          align-self: center;
        }
        button:hover {
          background: $blueBtn;
          color: white;
        }
        p {
          margin-left: 32px;
        }
      }
    }
  }

  .pc-list-table {
    overflow: visible !important;
    .btnViewDetail {
      width: 90px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid $timeBtn;
      outline: none;
      background: none;
      font-family: $chinese;
      font-size: 12px;
      color: $timeBtn;
      cursor: pointer;
    }
    .btnViewDetail:hover {
      background: $bpDetail;
      color: $blueBtn;
    }
    /deep/ .el-table__body-wrapper {
      min-height: 713px;
    }
    /deep/ .cell {
      text-align: center !important;
      font-family: $chinese !important;
      font-size: 14px !important;
      color: $mainTitle !important;
    }
    /deep/ .is-leaf {
      border-top:1px solid #EBEEF5;
      background: $base-color !important;
      font-weight: normal !important;
    }
    /deep/ .el-switch__core {
      width: 54px !important;
      height: 20px !important;
      display: flex;
      align-items: center;
    }
    .switch-is-active {
      /deep/ .el-switch__core {
        &::before {
          content: "有效";
          font-size: 8px;
          color: white;
          padding-left: 6px;
        }
      }
    }
    .switch-is-not-active {
      /deep/ .el-switch__core {
        &::before {
          content: "无效";
          font-size: 8px;
          color: white;
          padding-left: 22px;
        }
      }
    }
  }

  .pagination {
    margin-top: 45px;
  }
  /deep/ .pc-pagin {
    justify-content: flex-end !important;
  }
}
.eltable-img {
  max-width: 100px;
  max-height: 50px;

  img {
    width: 130px;
    height: 50px;
    object-fit: contain;
  }
}
/deep/ .el-table__header {
  .has-gutter {
    tr {
      th {
        .cell {
          color: $timeWorld !important;
          .el-checkbox {
            color: $timeWorld;
          }
        }
      }
    }
  }
}
// /deep/ .el-checkbox__label{
//   padding-left: 7px;
// }
</style>


// WEBPACK FOOTER //
// src/components/admin/bestPractice/components/BestPracticeTable.vue